import script from "./OrderRecordsView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderRecordsView.vue?vue&type=script&setup=true&lang=js"

import "./OrderRecordsView.vue?vue&type=style&index=0&id=7df7597a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7df7597a"]])

export default __exports__